import script from "./InformationCardField.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationCardField.vue?vue&type=script&lang=ts&setup=true"

import "./InformationCardField.vue?vue&type=style&index=0&id=68831e29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68831e29"]])

export default __exports__